import { DeviceWidth } from 'ecs-react-components/dist/index.es';
import { messages } from './TestResults.i18n';

export const columns = [
  {
    name: 'ID',
    dataField: 'testResultDetailId',
    isKey: true,
    hidden: true,
    formatted: true,
  },
  {
    name: messages.tableColumns.test,
    dataField: 'testDisplayName',
  },
  {
    name: messages.tableColumns.result,
    dataField: 'testValue',
  },
  {
    name: messages.tableColumns.units,
    dataField: 'unitOfMeasure',
    maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
  },
  {
    name: messages.tableColumns.referencesRange,
    dataField: 'referencesRange',
    maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
  },
  {
    name: messages.tableColumns.flag,
    dataField: 'abnormalFlag',
    maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
  },
  {
    name: messages.tableColumns.status,
    dataField: 'testDetailStatus',
    maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
  },
  {
    name: messages.tableColumns.comment,
    dataField: 'comment',
    maxCollapsedWidth: DeviceWidth.XSmall.maxWidth,
  },
];
